import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { Response } from '../../../types/typeHelper';

export type FavoriteState = {
  favorites: Response<'/chat/favorites', 'get'>['favorites'];
};

const initialState: FavoriteState = {
  favorites: [],
};

const persistWhitelist = ['favorites'];

const favoritesSlice = createSlice({
  name: 'favorites',
  initialState,
  reducers: {
    favoritesUpdated: (
      state,
      action: PayloadAction<{ favorites?: Response<'/chat/favorites', 'get'>['favorites'] }>,
    ) => {
      const { favorites } = action.payload;
      state.favorites = favorites ?? [];
    },
  },
});

export { persistWhitelist as favoritesPersistWhitelist };
export const { favoritesUpdated } = favoritesSlice.actions;
export default favoritesSlice.reducer;
